
export default function BrandStory() {
  return (
    <section id="our-story" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden h-[560px]">
              <img
                src="https://public.readdy.ai/ai/img_res/8623fb09b15bac5d62f88e84a85cebec.jpg"
                alt="Daliah Secret Founder crafting perfumes"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#2E7D32] text-white rounded-2xl px-8 py-6 shadow-xl">
              <p className="text-4xl font-serif font-bold">20+</p>
              <p className="text-sm text-[#A5D6A7] tracking-wide">Years of Craft</p>
            </div>
          </div>

          <div>
            <p className="text-[#2E7D32] text-sm tracking-[0.2em] mb-3 font-medium">
              HOW IT ALL BEGAN
            </p>
            <h2 className="text-4xl font-serif text-gray-900 mb-6 leading-snug">
              A Journey Rooted in <br />Nature&apos;s Elegance
            </h2>
            <div className="space-y-5 text-gray-600 text-[15px] leading-relaxed">
              <p>
                Daliah Secret was born from a deeply personal journey. Growing up surrounded by the 
                fragrant gardens of the Mediterranean, our founder discovered the transformative power 
                of natural scents at a young age — how a single note of jasmine could evoke a cherished 
                memory, or how the warmth of oud could inspire quiet confidence.
              </p>
              <p>
                What began as a small collection of hand-blended perfumes shared among friends quickly 
                blossomed into something extraordinary. Each creation was met with the same response: 
                &ldquo;This feels different. This feels real.&rdquo; That authenticity became the foundation 
                of everything we do.
              </p>
              <p>
                Today, Daliah Secret is a celebration of nature&apos;s most precious gifts — from the 
                sun-drenched rose fields of Grasse to the ancient argan groves of Morocco. Every bottle 
                we craft carries the same passion and precision that inspired our very first blend.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
